import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface GetClaimGroupHandlingQueryArgs {
  claimGroupId: string;
}

export const getClaimGroupHandlingRequest = ({
  claimGroupId,
}: GetClaimGroupHandlingQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/handling`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimGroupHandlingQuery = async (
  args: GetClaimGroupHandlingQueryArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getClaimGroupHandlingRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
